import module from 'module';
import _ from 'lodash';

import templateUrl from './red-flag-alert-notification.template.html';
import './red-flag-alert-notification.style.less';

class RedFlagAlertNotification {
  constructor($scope, $location, $interval, commandAccessChecker, config, redFlagAlertNotificationService) {
    this.$scope = $scope;
    this.$location = $location;
    this.$interval = $interval;
    this.commandAccessChecker = commandAccessChecker;
    this.config = config;
    this.redFlagAlertNotificationService = redFlagAlertNotificationService;
  }

  async $onInit() {
    this.resetRedFlagAlertNotificationsListAndDifference();

    const [systemAlertsEnabled,
           canExecuteCommand
    ] = await Promise.all([
      this.redFlagAlertNotificationService.isSystemAlertsEnabled(),
      this.commandAccessChecker.canExecuteCommandPromise()
    ]);

    const canAcknowledgeSystemAlerts = canExecuteCommand('AcknowledgeRedFlagAlert');

    if (systemAlertsEnabled && canAcknowledgeSystemAlerts) {
      // Run once, then let the interval run, then create the listener.
      this.redFlagAlertNotificationService.fetchNotifications();
      this.$interval(() => this.redFlagAlertNotificationService.fetchNotifications(), this.config.redFlagAlertNotificationInterval);
      this.$scope.$on('redFlagNotifications', () => {
        const notifications = this.redFlagAlertNotificationService.getNotifications();
        this.resetRedFlagAlertNotificationsListAndDifference();
        if (notifications && notifications.length) {
          this.redFlagAlertNotifications = notifications;
          this.difference = notifications[0].totalPending - notifications.length;
        }
      });
    }
  }

  resetRedFlagAlertNotificationsListAndDifference() {
    this.difference = 0;
    this.redFlagAlertNotifications = [];
  }

  goToAcknowledgementsPage() {
    this.$location.path('/admin/compliance/red-flag-acknowledgement');
  }
}

module.component('redFlagAlertNotification', {
  templateUrl: templateUrl,
  controller: RedFlagAlertNotification
});